export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content;
}

export function fetchWithCsrf(url, options = {}) {
  const token = csrfToken();
  const headers = new Headers(options.headers || {});

  if (token) headers.set('X-CSRF-Token', token);

  return fetch(url, { ...options, headers, credentials: options.credentials || 'same-origin' });
}
